
export class HashHelper {
  public static getGuid(): number {
    return parseInt(Math.random().toString().substring(2, 16), 10);
  }
}
